export default __webpack_public_path__ + "static/media/copy_paste.3e7e7e3d.svg";